import React from 'react';
import { connect } from 'react-redux';
import Top from '../Top/Top';
import ProductList from './ProductList';
import TemplateParserDeprecated from '../Templates/TemplateParserDeprecated';
import { listItemCache } from '../../actions/checkout';
import { toggleFavourite } from '../../actions/environment';
import s from './Category.scss';

const Category = ({ setup, categoryData, brands, favourites, productCache, filter, data = {}, currentPath = '', listingId = false, ...props }) => {
	const cache = productCache?.[setup.market]?.[setup.pricelist];
	if (!data || !cache) return null;
	const specificSections = data?.content?.section;

	return (
		<main className={[s.category, listingId ? s.category__embed : null].join(' ')} role="main">
			{ data.content && <Top setup={setup} pageContent={data.content} paths={data.paths} /> }
			{ specificSections && specificSections.length > 0 && <TemplateParserDeprecated sections={specificSections} setup={setup} /> }
			<ProductList filter={filter} brands={brands} filtering={cache} data={data} setup={setup} currentPath={currentPath} resetFilter={props.resetFilter} />
		</main>
	);
};

const mapState = ({ environment, productCache, filter }, props) => ({
	setup: environment.setup,
	categoryData: environment?.categoryData,
	brands: environment.brands,
	favourites: environment.favourites,
	productCache,
	filter,
	...props,
});

export default connect(mapState, { toggleFavourite, listItemCache })(Category);
